module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "div_intro"
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-002"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('h1', {
    staticClass: "pre_tit"
  }, [_c('span', [_vm._v("Introduction")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Let’s begin a book on prayer in a bar.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The roaring twenties were marked by brilliant jazz musicians and new forms of dancing. Women made significant gains in the workplace, and the female voice was for the first time being heard on ballots. The country’s citizens were connected to one another, and innovation was launching them into new terrain. City life was becoming a focal point, with the farm fading in the rearview mirror of the Model T. And on January 16, 1920, the federal Volstead Act closed every tavern, bar, and saloon in the country. Most likely, that same day the speakeasy was birthed. When people across the country found their favorite bars closed, they sought to create an alternate reality for the consumption of their favorite libations.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The original speakeasies were places filled with excitement and exclusion. To gain entrance to the club, you would approach the unmarked door and knock twice, and then a small peephole would slide open just wide enough for a pair of eyes to appear and prompt you for the password. The right word granted you entrance into a brand-new world, and the wrong word left you in the alley only able to hear the faint whisper of the roaring jazz music dancing in the damp night air.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("The quest for a deeper spiritual life has often left me on the outside looking in. I grew up in church and have heard more sermons than I can count. The songs of the church filled my ")]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("family’s home while we sang our theology in three-part harmony. I have heard stories of God’s faithfulness and nearness for as long as I can remember—yet I found myself without the right password to gain entrance. All of the talk about a deeper walk, a more powerful prayer life, left me feeling like the church was a spiritual speakeasy that housed the music, community, and the Spirit. It promised everything I wanted, but I didn’t have the password to gain entry.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("When Jesus speaks of the kingdom he does so with childlike simplicity, and yet I was finding it more and more difficult to feel like I was a part. If you have ever felt like going deeper in your relationship with Jesus is just beyond your grasp, keep reading. If you have ever wanted to find the right words to guide you to God, this book is for you. If you have ever wanted it to not be so difficult, it’s simpler than you’ve been told.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-001"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("WHAT IS SIMPLE PRAYER?")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("The word "), _c('i', [_vm._v("simple")]), _vm._v(" means not hard to understand, not complex or fancy. Simple prayer acknowledges who I am in light of who God is and leaves no need for many words. Often when I don’t know what to say I say too much. Proverbs says that when words are in excess, sin isn’t absent (Proverbs 10:19). Many words or complex thoughts do not equal nearness to God. The role of prayer in our lives is like the facets on a diamond—many angles and new brilliance are displayed at each turn. Prayer aligns us with God, and our thinking is renewed in light of that connection. Simple prayer strips away the dross that fills our speech and gives us a direct connection to God. It is not less prayer—it is indeed more. Simple prayer is a way of praying that keeps the focus of our prayers in ")]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("clear view. This model of prayer is at once accessible to someone exploring spirituality and provides plenty of depth for the seasoned Christ-follower.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("The life of simple prayer is a prayerful life that unfolds behind the scenes, often unheard. It is a way to recalibrate your prayer life and bring renewal when prayers become focused on everything but God alone. The beauty in prayer comes when the desire to be with God is greater than the desire to get things from God, when our word count is less important than the language we use.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("This book will introduce simple prayer in a way that invites you to practice what you are reading. A book on prayer is less effective than a book that leads you in prayer, and planning times of prayer as you read this book will help you take to heart this practice that has been so life changing for me.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-002"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("WHY IS SIMPLE PRAYER IMPORTANT?")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("Prayer is at the forefront of the spiritual life and is essential to our development as disciples. Prayer is found throughout the Bible, yet it remains difficult for most of us. We want to pray, but don’t know how. We long for depth in our spiritual lives, but aren’t sure how to launch out into the deep. Most of us can remember who taught us how to ride a bike or throw a baseball, but can we name the person who taught us to pray? If we are pushed on the matter, we realize that we likely weren’t taught "), _c('i', [_vm._v("how")]), _vm._v(" to pray but rather were told "), _c('i', [_vm._v("about")]), _vm._v(" prayer.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("Simple prayers have been an important part of my spirituality, providing a means of prayer in times when it was difficult to pray. They have also invited me to strip away all the meaningless words with which I tend to fill my prayers so I can get down to the heart ")]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("of prayer—being with God. By introducing me to a prayer life that is sustainable and accessible, simple prayers have made all the difference in my life.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("Simple prayers are important to help form our prayer lives and allow us to create rhythms in our inner lives that we can build on. Simple prayers keep us moving toward God. They create a foundation on which the rest of our prayers stand. They provide places to start or places to return.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("Simple prayers have been prayed for centuries. We find them throughout the Scriptures and scattered throughout our lives—in songs and literature, in conversations about God, in conversations with our kids. A practice of simple prayer gives us the opportunity to pick up these gems, dust them off, and begin to pray the way Jesus prayed, the way he taught the disciples, and the way countless other followers of Jesus have prayed throughout the centuries.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-003"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("PRAYERS FILLED WITH PURPOSE")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("Simple prayers are not lazy prayers; they are purposed prayers. Simple prayer is not getting out of prayer or reducing our experience; it is becoming deliberate in our language regarding the things that matter. I have a deep desire to make my words count. I want to carefully choose words that paint a picture and capture emotions or thought, but I also want to do that in a way that is most accessible and effective. A good poet knows that the right word is better than ten almost right words. These right words aren’t hidden; they are scattered all around for us to find. Simple prayer reminds us that prayer isn’t for those with access to secret places or pedigree but for all of us.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("Prayer has many facets, and simple prayer is one of them. The biblical call to prayer without ceasing is better translated, “Come to rest")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-001",
      "id": "ap_ntf-001-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(".” Prayer is a restful and reflective activity. Prayer is being present to God and being renewed and reformed in his image. It is part dialogue and part enjoyment of being with him. It is deep breaths of refreshing and passionate cries from our hearts. Simple prayers are not void of emotion; they are calculated and focused emotion: say-what-we-mean-and-mean-what-we-say types of prayers. If we are not careful, our prayer lives will look more like the pagan worship in the Old Testament, when people were certain the gods heard them based on their expressive language and rituals. In contrast, Jesus taught us to pray in a way that is honest, heartfelt, and simple.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-004"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("PRAYING LIKE YOU MEAN IT")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In the summer of 1998, I became the youth pastor at the church in which I grew up, situated in the shadows of Disney World and Universal Studios in central Florida. I remember my first day quite clearly. My heart was brimming with excitement, and enthusiasm was seeping out of the corners of my smile. I marched up the sidewalk to the outside office door, extended my hand to greet the doorknob, and with a deep breath turned the handle and entered the office.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("My pastor had been a mentor and friend for years. Now we were working together, and he was as excited as I was. He had a smile as big as mine. He looked me right in the eye and asked, “Are you ready to get to work?”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Truth be told, I had no idea what that meant or what I was getting myself into, but without hesitation I exclaimed, “Yes!”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("He replied, “Follow me.” He walked to the door that led to the sanctuary, opened the door, and disappeared.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("Before the door fully closed, I slid through and entered a few steps behind him. He walked off the stage and down two more steps to the altar area. “Charlie, I am excited for you to work here. Now here is your first lesson in ministry. Work begins in here, in prayer before anything else. The rest can wait. The phones will ring and mail will be delivered, but first things first. We pray.” He turned to the left and began to walk the room and pray. His walk wasn’t a march; it was a stroll. He wasn’t in a hurry or on a mission. He was going somewhere, but nowhere near where we were. If you looked closely you could see the familiar path of his footsteps impressed on the faded blue carpet. I just knelt down at the altar and began to pray.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("I prayed for everything that I could think of. I prayed for family members to be saved, I prayed for every friend and world leader I could recall. I prayed for world peace and for hunger to be quenched throughout the earth. I believed that because of my passion and it being my first day on the job, God would be inclined to respond as I requested. I was certain that due to the intensity of my prayer drops of blood were forming on my head, so I patted my head with the end of my shirt. I looked at my watch to see how much time had passed. To my surprise, it had only been ten minutes. I turned my head to see how my pastor was doing, and he smiled at me and kept walking and praying. Feeling inadequate, I turned from my kneeling position to sitting on the floor with my back leaning against the altar, and I began to listen.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("At that time, I wasn’t aware of the instruction that I was receiving from my pastor. I was learning what it meant to be a ")]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("person who prayed. His prayers were not filled with vernacular that was impossible to understand. They were simple words, simple phrases. Simple prayers might have been whispered from his lips, but they roared in heaven. I sat clinging to every word. I began to repeat them softly as if they were my own. That was the first day that I allowed another person’s prayers to be my own. The words didn’t lose meaning when I borrowed them; they grew stronger in my heart. They became my own. I didn’t learn any techniques or tricks of the trade that day. We didn’t dialogue about ministry philosophy or the mission, vision, and values of the church. We prayed simple prayers.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-005"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("PRAYER FOR WHEREVER YOU ARE")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("As we launch into the rest of this book, the goal is to provide you with a collection of simple prayers to interact with and make your own. They come from places far and wide and give the reader an entry into a life of prayer that is simple but not simplistic. The purpose of simple prayer is to find our hearts closer and more connected to God. Prayer is the vehicle that brings us to the Father, and it is prayer that creates space for us to settle in. This book is for those desiring to live a life of prayer that is not disjointed.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("Simple prayers are all around us. They are found in Scripture. They are hidden in our daily lives. They swirl around our hearts and minds and rest on the tips of our tongues. Simple prayers are for both the novice seeker and the well-worn traveler on the journey of faith. Where do you find yourself at this moment? Are you new to faith? Have you been on this faith walk for years? Do you feel like you are losing your way? Do you feel the wind at your back propelling you into unchartered waters and have a rising ")]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("anxiety about the unknown? Maybe you are looking for a way to deepen your prayer life. Then it is time to simply pray. We can trust that before we even articulate our thoughts, emotions, or needs, God already knows and desires to respond. A simple prayer paves the way for us to know and be known by God.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("This book is for those too busy to pray and for those who have found their prayers to be lifeless. This is a chance to connect our prayer with historic prayers that have carried believers for centuries, and for those prayers to create space in our inner lives for us to be with God. Perhaps what we need are fewer books to tell us about prayer and more that help us pray. I hope you will find this book to be the latter.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("Let’s pray.")])])])])])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30defbe2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre3.vue
// module id = 69
// module chunks = 0